// @flow
import React from 'react';
import PropTypes from 'prop-types';
import type { Element } from 'react';

import TileGridContentComponent from '../tile-grid-content/TileGridContentComponent';

import './TileGrid.scss';

type Props = {
  children?: Array<Element<typeof TileGridContentComponent>>,
};

/**
 * Responsive grid of tiles
 */
const TileGridComponent = ({ children }: Props) => {
  return (
    children && (
      <div className="tile-grid-component">
        <div className="tile-grid-component__layout">
          {children.map((childTile: Element<typeof TileGridContentComponent>, index: number) => (
            <div className="tile-grid-component__item" key={childTile.key || `tile-${index}`}>
              {childTile}
            </div>
          ))}
        </div>
      </div>
    )
  );
};

TileGridComponent.displayName = 'TileGrid';

TileGridComponent.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node.isRequired).isRequired,
};

export default TileGridComponent;
